import React, { Fragment } from "react";
import Label from "./Label";

const TelephoneInput = passedProps => {
  const {
    label,
    helpText,
    name,
    value,
    handleChange,
    placeholder,
    required,
    ...props
  } = passedProps;
  return (
    <Fragment>
      <Label htmlFor={name} helpText={helpText} required={required}>
        {label}
      </Label>
      <input
        className="form-control"
        id={name}
        name={name}
        type="tel"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        {...props}
      />
    </Fragment>
  );
};

export default TelephoneInput;
